import { createFileRoute } from "@tanstack/react-router";
import { replaceWithBareModule } from "@/app/module-address";
import { tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/reports")({
  // Retired `?tab=` ids resolve to the tab that absorbed them — `app/tabs.ts`.
  // The address that remains is `/reports`.
  validateSearch: tabSearch("reports"),
  beforeLoad: (args) => {
    replaceWithBareModule("/reports", args.location);
    requirePerm("VIEW_REPORT")(args);
  },
  component: () => <PendingSurface titleKey="nav.reports" />,
});
